import React from 'react';
import {
  SaleProductPrice,
  SaleProductVariant,
  useTranslator,
} from '@front-activerse/common-components';
import { currencySymbols } from '../const';

interface ISummaryContainer {
  values: { saleMethod: string };
  product: {
    saleProductVariant: SaleProductVariant;
    price: SaleProductPrice;
  };
  productPrice: SaleProductPrice;
  deliveryOptionPrice: {
    amount: number;
    currency: 'PLN';
    __typename: string;
  };
  totalPrice: {
    amount: number;
    currency: 'PLN';
  };
  disableCodOption?: boolean;
}

const SummaryContainer: React.FC<ISummaryContainer> = ({
  values,
  product,
  productPrice,
  deliveryOptionPrice,
  totalPrice,
  disableCodOption,
}) => {
  const { t } = useTranslator();

  return (
    <>
      <h3 className="title-medium semi-bold mb-xl">{t('paymentMethods.summary.title')}</h3>
      <div>
        <div className="d-flex justify-content-between">
          <p
            className="mb-0 pe-4"
            dangerouslySetInnerHTML={{
              __html: product.saleProductVariant.saleProduct.productCardTitle || '',
            }}
          />
          {!disableCodOption && (
            <p className="mb-0 text-nowrap">
              {productPrice.amount} {currencySymbols[productPrice.currency]}
            </p>
          )}
        </div>

        {(!product.saleProductVariant.saleProduct.isVirtual || values.saleMethod === 'cod') && (
          <>
            <hr />

            <div className="d-flex justify-content-between">
              <p className="mb-0">{t('paymentMethods.summary.delivery')}</p>
              <p className="mb-0">
                {deliveryOptionPrice.amount === 0
                  ? 'GRATIS'
                  : deliveryOptionPrice.amount +
                    ' ' +
                    currencySymbols[deliveryOptionPrice.currency]}
              </p>
            </div>
          </>
        )}

        <hr />
        <div className="d-flex justify-content-between">
          <h3 className="title-medium semi-bold mb-0">{t('paymentMethods.summary.total.title')}</h3>
          <h3 className="title-medium semi-bold mb-0">
            {totalPrice.amount + ' ' + currencySymbols[totalPrice.currency]}
          </h3>
        </div>
      </div>
    </>
  );
};

export default SummaryContainer;
